import axios from 'axios'
import { Course } from '@js/api/types/course/Course'
import { env } from '@js/utils/env'

export interface GetCoursesPayload {
  ids: number[];
}

export interface GetCoursesResponse {
  data: Course[]
}

/**
 * Fetches course data by IDs
 *
 * @param payload - Object containing an array of course IDs
 * @returns Promise with course data
 */
export const getCourses = async (payload: GetCoursesPayload): Promise<GetCoursesResponse> => {
  try {
    const queryParams = payload.ids.map(id => `ids[]=${id}`).join('&')

    const response = await axios.get<{data: Course[]}>(`${env.BASE_URL}/api/dashboard/courses.json?${queryParams}`)

    return response.data
  } catch (error) {
    console.error('Error fetching courses:', error)
    throw error
  }
}
